import React, { useState } from 'react'
import { Col, message } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import {
  getEncryptedID,
  isString,
  removeSpacewithLowerCaseString,
  StringIsNullOrEmpty
} from '../../appRedux/actions/GlobalMethods'
import {
  loadQuicKeyDetails,
  loadIsFolderActive,
  loadQuickKeyCount,
  loadActiveFolderData,
  loadActiveColorCode,
  loadIsProductLoading
} from '../../appRedux/actions/MainSale'
import {
  loadSellProductDetails,
  loadSellScreenLoading
} from '../../appRedux/actions/Sell'
import {
  loadIsShowVariantModal,
  loadVariatSelectedProdID
} from '../../appRedux/actions/CommonData'
import { FolderOutlined } from '@ant-design/icons'

const QuickKeys = props => {
  const outlet = props.outlet ? props.outlet : ''
  const dispatch = useDispatch()

  const getQuickkeyCount = useSelector(
    ({ MainSale }) => MainSale.getQuickkeyCount
  )
  const getQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getQuickKeysDetails
  )
  const getMainQuickKeysDetails = useSelector(
    ({ MainSale }) => MainSale.getMainQuickKeysDetails
  )
  const getIsFolderActive = useSelector(
    ({ MainSale }) => MainSale.getIsFolderActive
  )
  const getReduxSellProductDetail = useSelector(
    ({ Sell }) => Sell.getSellProductDetails
  )
  const getReduxSellSelectedProd = useSelector(
    ({ Sell }) => Sell.getSellSelectedProducts
  )
  const getReduxIsRegisterOpen = useSelector(
    ({ Sell }) => Sell.cashManageIsRegistorOpen
  )
  const getIsOutInvWarn = useSelector(
    ({ commonConfigs }) => commonConfigs.getIsOutInvWarn
  )
  const getReduxSelectedStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseSelectedStoreOutlets
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)

  const [getSelectedOutlet, setSelectedOutlet] = React.useState('')

  var totalQuickKeyCount = getQuickkeyCount.rows * getQuickkeyCount.columns
  var quickKeyDetails = getQuickKeysDetails.filter(e =>
    e.isFolderProduct == getIsFolderActive ? true : false
  )

  React.useEffect(() => {
    let outletID = ''
    if (getReduxSelectedStoreOutlets.id) {
      outletID = getReduxSelectedStoreOutlets.id
      setSelectedOutlet(outletID)
    } else {
      let selectedLocalOut = localStorage.getItem('selectedOut')
      if (selectedLocalOut) {
        selectedLocalOut = JSON.parse(selectedLocalOut)
        outletID = getReduxSelectedStoreOutlets.id
          ? getReduxSelectedStoreOutlets.id
          : selectedLocalOut.id

        setSelectedOutlet(outletID)
      }
    }
  }, [getReduxSelectedStoreOutlets])

  const scroll = () => {
    const section = document.querySelector('#bottom-cart-footer')
    section.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
  const handleClickQuickeyActive = (e, index, data) => {
    if (data != undefined) {
      if (!getReduxIsRegisterOpen) {
        message.info('Kindly open Register to sell products')
      } else {
        if (data.isFolder != true || getIsFolderActive) {
          if (
            data.productType &&
            data.productType.includes('Variant') &&
            data.hasChild &&
            data.parentProductID < 1
          ) {
            // setVisible(true);
            // setSelectedProdID(data.productID);
            dispatch(loadSellScreenLoading(true))
            dispatch(
              loadVariatSelectedProdID(
                isString(data.productID) && data.productID.includes('&')
                  ? data.productID
                  : `${data.productID}&&_9efa-1ea9-4faf-88ed-a48e65b46643`
              )
            )
            dispatch(loadIsShowVariantModal(true))
            let body = {
              productID: getEncryptedID(data.productID),
              outletID: outlet,
              containVariants: true
            }
            dispatch(
              loadSellProductDetails(
                body,
                getReduxSellProductDetail,
                getReduxSellSelectedProd,
                getIsOutInvWarn,
                isOnline,
                getSelectedOutlet,
                getReduxStoreInfo
              )
            )
          } else {
            dispatch(loadIsProductLoading(true))
            const body = {
              productID: getEncryptedID(data.productID),
              outletID: outlet,
              containVariants: false
            }

            dispatch(
              loadSellProductDetails(
                body,
                getReduxSellProductDetail,
                getReduxSellSelectedProd,
                getIsOutInvWarn,
                isOnline,
                getSelectedOutlet,
                getReduxStoreInfo
              )
            )
          }
        } else if (data.isFolder == true) {
          let mainData = getMainQuickKeysDetails
          let folderData = mainData.filter(
            e =>
              e.isFolder != true &&
              removeSpacewithLowerCaseString(e.folderName) ==
                removeSpacewithLowerCaseString(data.folderName)
          )
          // setActiveColorCode(data.colorCode);
          dispatch(loadActiveColorCode(data.colorCode))
          // setQuicKeyDetails(folderData);
          dispatch(loadQuicKeyDetails(folderData))
          // setActiveFolderData(data);
          dispatch(loadActiveFolderData(data))
          // setQuickKeyCount([{ rows: 5, columns: 5 }]);
          dispatch(loadQuickKeyCount({ rows: 5, columns: 5 }))
          // setIsFolderActive(true);
          dispatch(loadIsFolderActive(true))
        }
      }
    }
    // scroll();
  }

  return Array.apply(0, Array(totalQuickKeyCount)).map(function (x, i) {
    let data = quickKeyDetails.filter(
      e => e.displaySeqNo == i && e.isDeleted == false
    )[0]

    let folderProductCount =
      data != undefined && data.isFolder != undefined
        ? data.isFolder
          ? getQuickKeysDetails.filter(
              e =>
                e.isDeleted == false &&
                e.isFolder == false &&
                e.parentKey == data.key
            ).length
          : '01'
        : '0'
    return (
      <div className='dk-flex-sale-item' key={i}>
        <div
          className={` droptarget  ${i} ${
            data != undefined && data.isFolder != undefined
              ? data.isFolder
                ? 'dk-quick-key--folder'
                : data.productID != null
                ? ''
                : 'dk-sale-quick-key--blank'
              : 'dk-sale-quick-key--blank'
          } `}
          style={{
            backgroundColor:
              data != undefined && data.isFolder != undefined
                ? data.isFolder
                  ? data.colorCode
                  : ''
                : ''
          }}
          key={i}
          displayseqno={i}
          isfolder={
            data != undefined && data.isFolder != undefined
              ? data.isFolder.toString()
              : 'false'
          }
          labelname={
            data != undefined &&
            data.isFolder != undefined &&
            data.label != undefined
              ? data.isFolder
                ? data.folderName
                : data.label
              : ''
          }
          onClick={e => handleClickQuickeyActive(e, i, data)}
        >
          {data != undefined && data.isFolder != undefined ? (
            data.isFolder ? (
              <div
                isfolder={
                  data != undefined && data.isFolder != undefined
                    ? data.isFolder.toString()
                    : 'false'
                }
                className='products-folder-head'
                id={'dragMe' + i}
              >
                <div className='qk-card-head'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <FolderOutlined />
                    <p className='mb-0'>{folderProductCount}</p>
                  </div>
                </div>
                <div className='dk-quick-key-card-body'>
                  <h3 className='custom-text-center text-color-white dk-quick-key-label QK-text'>
                    {data.folderName}
                  </h3>
                </div>
              </div>
            ) : data.productID != null && data.isActiveOnSale && data.isActive ? (
              <div
                isfolder={
                  data != undefined && data.isFolder != undefined
                    ? data.isFolder.toString()
                    : 'false'
                }
                className='gx-card'
                id={'dragMe' + i}
              >
                <div
                  className='qk-card-head'
                  style={{ backgroundColor: data.colorCode }}
                ></div>
                <div className='dk-quick-key-card-body'>
                  {data.isShowImages && !StringIsNullOrEmpty(data.imageURL) ? (
                    <div
                      className='dk-quick-key-image'
                      style={{ backgroundImage: `url(${data.imageURL})` }}
                    ></div>
                  ) : (
                    <div className='dk-quick-key-image dk-empty-bg'></div>
                  )}
                  <h3 className='dk-quick-key-label'>
                    {data.label}
                  </h3>
                </div>
              </div>
            ) : (
              <div className=' '></div>
            )
          ) : (
            <div className=' '></div>
          )}
        </div>
      </div>
    )
  })
}

export default QuickKeys
